import { useQuery } from "@tanstack/react-query";

import { getPanelBrandSlug } from "@/config/config";

import { getAllowedProductTypes } from "./products.api";
import { EProductType } from "./products.type";

export const useAllowedProductTypes = () => {
  const panelBrand = getPanelBrandSlug();

  const query = useQuery<EProductType[]>({
    queryKey: ["allowed-product-types", panelBrand] as const,
    queryFn: getAllowedProductTypes,
    staleTime: 30 * 60 * 1000,
  });

  return {
    allowedTypes: query.data ?? [],
    isLoading: query.isLoading,
    isFetched: query.isFetched,
    error: query.error,
  };
};
